import React, { useState, useRef, useContext } from "react";
import { PlusCircle, Trash2 } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Navbar from "./Navbar";
import axios from "axios";
import languageContext from "../context/language/languageContext";

export default function PrescriptionForm() {
  const [patientName, setPatientName] = useState("");
  const {setAlert, setMessage,  setSessionTimeout } = useContext(languageContext);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [symptoms, setSymptoms] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [medicines, setMedicines] = useState([{ name: "", dosage: "", time: "", days: "" }]);
  const [labTests, setLabTests] = useState([""]);
  const [sos, setSOS] = useState("");
  const [notes, setNotes] = useState("");
  const pdfRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const handleAddMedicine = () => setMedicines([...medicines, { name: "", dosage: "", time: "", days: "" }]);
  const handleRemoveMedicine = (index) => setMedicines(medicines.filter((_, i) => i !== index));
  const handleMedicineChange = (index, field, value) => {
    const updated = [...medicines];
    updated[index][field] = value;
    setMedicines(updated);
  };

  const handleAddLabTest = () => setLabTests([...labTests, ""]);
  const handleRemoveLabTest = (index) => setLabTests(labTests.filter((_, i) => i !== index));
  const handleLabTestChange = (index, value) => {
    const updated = [...labTests];
    updated[index] = value;
    setLabTests(updated);
  };

  // const handleSubmit = async () => {
  //   const navbar = document.querySelector("nav"); // assuming Navbar uses <nav>
  //   if (navbar) navbar.style.display = "none";
  
  //   await new Promise((resolve) => setTimeout(resolve, 100));
  
  //   const canvas = await html2canvas(pdfRef.current, { scale: 2 });
  //   const imgData = canvas.toDataURL("image/png");
  //   const pdf = new jsPDF("p", "mm", "a4");
  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  //   pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //   pdf.save(`${patientName || "prescription"}.pdf`);
  
  //   if (navbar) navbar.style.display = "";
  // };
  

  const handleSubmit = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/generate_prescription",
        JSON.stringify({
          id: patient_id,
          patient_name:patientName,
          date:date,
          symptoms: symptoms,
          diagnosis:diagnosis,
          medicines:medicines,
          lab_tests:labTests ,
          sos: sos,
          notes:notes,
        }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setMessage(response.data.chat_history);
        navigate("/doctor-dashboard")

      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        console.error("Error Details:", error.message);
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };
  //   const input = pdfRef.current;
  //   if (!input) return;
  
  //   // ✅ Wait for the DOM to reflect updated state
  //   await new Promise((resolve) => setTimeout(resolve, 200));
  
  //   const canvas = await html2canvas(input, {
  //     scale: 2,
  //     useCORS: true,
  //   });
  
  //   canvas.toBlob(async (blob) => {
  //     if (!blob) return;
  
  //     const file = new File([blob], `${patientName || "prescription"}.png`, {
  //       type: "image/png",
  //     });
  
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     formData.append("patient_name", patientName);
  
  //     try {
  //       const response = await axios.post(
  //         "https://www.careplus.gopillz.com/prescription",
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );
  //       console.log("Upload success:", response.data);
  //     } catch (error) {
  //       console.error("Upload failed:", error);
  //     }
  //   });
  // };
  
  
    return (
      <div className="min-h-screen bg-gradient-to-r from-sky-50 to-blue-100">
        <Navbar />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="px-4 py-10 flex justify-center"
        >
          <div
            ref={pdfRef}
            className="w-full max-w-5xl bg-white rounded-3xl shadow-xl p-8 space-y-10 border border-blue-100"
          >
            <h1 className="text-4xl font-bold text-blue-700 text-center">
              🩺 Digital Prescription
            </h1>
    
            {/* Patient Info */}
            <div className="grid sm:grid-cols-2 gap-6">
              <div>
                <label className="text-sm font-semibold text-gray-700">Patient Name</label>
                <input
                  type="text"
                  placeholder="e.g., John Doe"
                  value={patientName}
                  onChange={(e) => setPatientName(e.target.value)}
                  className="mt-2 w-full rounded-xl border px-4 py-2 shadow-sm text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div>
                <label className="text-sm font-semibold text-gray-700">Date</label>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="mt-2 w-full rounded-xl border px-4 py-2 shadow-sm text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>
    
            {/* Symptoms & Diagnosis */}
            <div className="grid sm:grid-cols-2 gap-6">
              <div>
                <label className="text-sm font-semibold text-gray-700">🩹 Symptoms</label>
                <textarea
                  rows={3}
                  value={symptoms}
                  onChange={(e) => setSymptoms(e.target.value)}
                  placeholder="Describe symptoms"
                  className="mt-2 w-full rounded-xl border px-4 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div>
                <label className="text-sm font-semibold text-gray-700">🧠 Diagnosis</label>
                <textarea
                  rows={3}
                  value={diagnosis}
                  onChange={(e) => setDiagnosis(e.target.value)}
                  placeholder="Diagnosis details"
                  className="mt-2 w-full rounded-xl border px-4 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>
    
            {/* Medicines */}
            <div className="bg-blue-50 rounded-2xl p-5">
              <h2 className="font-semibold text-blue-700 text-lg mb-4">💊 Medicines</h2>
              {medicines.map((med, index) => (
                <div key={index} className="grid grid-cols-5 gap-3 items-center mb-2">
                  <input
                    type="text"
                    placeholder="Name"
                    value={med.name}
                    onChange={(e) => handleMedicineChange(index, "name", e.target.value)}
                    className="rounded-md border px-2 py-1 text-sm"
                  />
                  <input
                    type="text"
                    placeholder="Dosage"
                    value={med.dosage}
                    onChange={(e) => handleMedicineChange(index, "dosage", e.target.value)}
                    className="rounded-md border px-2 py-1 text-sm"
                  />
                  <input
                    type="time"
                    value={med.time}
                    onChange={(e) => handleMedicineChange(index, "time", e.target.value)}
                    className="rounded-md border px-2 py-1 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Days"
                    value={med.days}
                    onChange={(e) => handleMedicineChange(index, "days", e.target.value)}
                    className="rounded-md border px-2 py-1 text-sm"
                  />
                  <button onClick={() => handleRemoveMedicine(index)} className="text-red-500 hover:text-red-600">
                    <Trash2 size={18} />
                  </button>
                </div>
              ))}
              <button
                onClick={handleAddMedicine}
                className="flex items-center mt-2 text-blue-600 hover:text-blue-800 text-sm"
              >
                <PlusCircle size={18} className="mr-1" />
                Add Medicine
              </button>
            </div>
    
            {/* Lab Tests */}
            <div className="bg-blue-50 rounded-2xl p-5">
              <h2 className="font-semibold text-blue-700 text-lg mb-4">🧪 Lab Tests</h2>
              {labTests.map((test, index) => (
                <div key={index} className="flex items-center gap-3 mb-2">
                  <input
                    type="text"
                    placeholder="Test Name"
                    value={test}
                    onChange={(e) => handleLabTestChange(index, e.target.value)}
                    className="w-full rounded-md border px-2 py-1 text-sm"
                  />
                  <button onClick={() => handleRemoveLabTest(index)} className="text-red-500 hover:text-red-600">
                    <Trash2 size={18} />
                  </button>
                </div>
              ))}
              <button
                onClick={handleAddLabTest}
                className="flex items-center mt-2 text-blue-600 hover:text-blue-800 text-sm"
              >
                <PlusCircle size={18} className="mr-1" />
                Add Lab Test
              </button>
            </div>
    
            {/* SOS & Notes */}
            <div className="grid sm:grid-cols-2 gap-6">
              <div>
                <label className="text-sm font-semibold text-gray-700">🚨 SOS Instructions</label>
                <textarea
                  rows={3}
                  value={sos}
                  onChange={(e) => setSOS(e.target.value)}
                  placeholder="In case of emergency..."
                  className="mt-2 w-full rounded-xl border px-4 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div>
                <label className="text-sm font-semibold text-gray-700">📝 Additional Notes</label>
                <textarea
                  rows={3}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Doctor’s additional advice"
                  className="mt-2 w-full rounded-xl border px-4 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>
    
            {/* Submit Button */}
            <button
              onClick={handleSubmit}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl flex justify-center items-center gap-2 transition"
            >
              <PlusCircle size={20} />
              Save 
            </button>
          </div>
        </motion.div>
      </div>
    );
    
}
